import React from "react";
import BaseLayout from "../../templates/BaseLayout/BaseLayout";
import DeleteAccountTemplate from "../../templates/deleteAccountTemplate/DeleteAccountTemplate";

export default function DeleteAccountPage() {
    return (
        <DeleteAccountTemplate />
    );
}